import { JSX, Suspense } from "react";
import { useTranslation } from "react-i18next";

import TvCardSkeleton from "@/components/cards/TvCard/TvCard.skeleton.tsx";
import ChannelsList from "@/components/tv-channels/ChannelsList.tsx";
import FilterList from "@/components/tv-channels/FilterList.tsx";

const TvChannelsPage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <section
        className={`space-y-[1.5rem] rounded-[1.875rem] py-[1.875rem] max-lg:space-y-6 max-lg:rounded-[1.25rem] max-lg:py-6 max-lg:pt-2`}
      >
        <h1 className={"text-[2rem]/[111%] font-semibold max-lg:text-[1.875rem]/10"}>{t("General.tv-channels")}</h1>
        <FilterList className={``} />
      </section>
      <section
        className={
          "grid grid-cols-8 gap-5 rounded-[1.875rem] max-2xl:grid-cols-7 max-xl:grid-cols-6 max-lg:grid-cols-5 max-lg:py-1 max-md:grid-cols-4 max-sm:grid-cols-3"
        }
      >
        <Suspense
          fallback={
            <>
              {Array.from({ length: 16 }).map((_, index) => (
                <TvCardSkeleton key={index} />
              ))}
            </>
          }
        >
          <ChannelsList />
        </Suspense>
      </section>
    </>
  );
};

export default TvChannelsPage;
